import { render, staticRenderFns } from "./WeightListItem.vue?vue&type=template&id=626861ec"
import script from "./WeightListItem.vue?vue&type=script&lang=js"
export * from "./WeightListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports